import React from "react"
import { Link } from "gatsby"
import { Col, Image } from "react-bootstrap"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { AuthorDefault } from "../../utils/imageConst";


const PostLink = ({ post, index, site }) => {
    const author = post.frontmatter?.author;
    const siteinfo = site?.siteMetadata;
    const imageBlog = getImage(post.frontmatter.featured);
    const imageAuth = getImage(author?.img);
    return (
        <>
            <Col key={index}>
                <div className="card blog-list-card">
                    <div className="blog-image">
                        <Link to={post.fields.slug} itemProp="url">
                            <GatsbyImage loading="lazy" image={imageBlog} width={384} height={226} alt="featured" />
                        </Link>
                    </div>
                    <div className="blog-list-content">
                        <div className="article">
                            <div className="single-line-meta author-top d-flex align-items-center mb-3">
                                <div className="author-image me-3">
                                    {author?.img ? (
                                        <GatsbyImage loading="lazy" className="bio-avatar" image={imageAuth} width={30} height={30} alt="author-profile" />
                                    ) : (<Image loading="lazy" className="bio-avatar lazyload" src={AuthorDefault} width={30} height={30} alt="author-profile" />)}
                                </div>
                                <div className="author-content">
                                    <p className="author-name font-size-12 mb-0">
                                        {author?.name ? author?.name : siteinfo?.author}
                                    </p>
                                </div>
                                {/* <span className="inline-sep mx-1">|</span>
                                <p className="mb-0 font-size-12">{post.frontmatter.modifyDate}</p> */}
                            </div>
                            <h2 className="blog-title h4 mb-3"><Link to={post.fields.slug} itemProp="url"><span itemProp="headline"> {post.frontmatter.title}</span></Link></h2>

                            <p className="blog-content mb-3" dangerouslySetInnerHTML={{
                                __html: post.frontmatter.description || post.excerpt,
                            }} itemProp="description" />
                            <div className="mt-auto">
                                <Link to={post.fields.slug} itemProp="url" className="btn btn-link btn-sm px-0">
                                    <span>Read More</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                        <div className="article-footer">
                            <div className="d-flex align-items-center single-line-meta">
                                <p className="font-size-12 mb-0">
                                    {post.frontmatter.categories?.map((category, index) =>
                                        <Link
                                            key={index}
                                            // to={`/blog/category/${category}`.toLowerCase().replace(/ /g, "-")}
                                            to={`/blog/category/${category.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`}
                                            rel="category tag"
                                            className="category"
                                        >{category} <i className="coma-sep"> , </i></Link>)}
                                </p>
                                <span className="inline-sep mx-1">|</span>
                                <p className="font-size-12 mb-0">
                                    {post?.fields?.timeToRead?.text}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        </>
    );
}

export default PostLink